import Config from "../config/config.js";
import { AppenData, axiosFunc } from "./common";

const errMsg = (msg) => {
  return { status: false, message: msg.toString() };
};

export const adminlogin = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/adminlogin`,
      data: data,
    });

    return respData.data;
  } catch (err) {
    console.log("🚀 ~ adminlogin ~ err:", err);

    errMsg(err);
  }
};

export const getAssetlist = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}admin/getassetlist`,
      params: data,
    });

    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getAssetlist ~ err:", err);

    errMsg(err);
  }
};

export const AssetStatusChange = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/assetstatuschange`,
      data: data,
    });

    return respData.data;
  } catch (err) {
    console.log("🚀 ~ AssetStatusChange ~ err:", err);
    errMsg(err);
  }
};

export const newWorkListGet = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}admin/getnetwork`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ newWorkListGet ~ err:", err);
    errMsg(err);
  }
};

export const networkHideShowAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/networkhideshow`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ networkHideShowAxios ~ err:", err);
    errMsg(err);
  }
};

export const netWorkEdit = async (data) => {
  console.log("🚀 ~ netWorkEdit ~ data:", data);
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/editnetwork`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ networkHideShowAxios ~ err:", err);
    errMsg(err);
  }
};

export const netWorkAdd = async (data) => {
  console.log("🚀 ~ netWorkEdit ~ data:", data);
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/addnetwork`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ netWorkAdd ~ err:", err);
    errMsg(err);
  }
};

export const categoryGet = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}admin/getcategory`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ categoryGet ~ err:", err);
    errMsg(err);
  }
};

export const categoryhideshowAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/categoryhideshow`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ categoryhideshowAxios ~ err:", err);
    errMsg(err);
  }
};

export const categoryAdd = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/addcategory`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ categoryAdd ~ err:", err);
    errMsg(err);
  }
};

export const categroyEditaxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/editcategory`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ categroyEdit ~ err:", err);
    errMsg(err);
  }
};

export const assetSendFeedbackAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/sendassetfeedback`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ assetSendFeedbackAxios ~ err:", err);
    errMsg(err);
  }
};

export const getSocialLinkAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}admin/getsocial`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getSocialLinkAxios ~ err:", err);
    errMsg(err);
  }
};

export const sicialHideShowAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/sociallinkhideshow`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ sicialHideShowAxios ~ err:", err);
    errMsg(err);
  }
};

export const socialAdd = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/socialadd`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ categroyEdit ~ err:", err);
    errMsg(err);
  }
};

export const socialEdit = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/socialedit`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ socialEdit ~ err:", err);
    errMsg(err);
  }
};

export const addQuestionaxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}common/questionadd`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ addQuestion ~ err:", err);
    errMsg(err);
  }
};

export const getQuestionAxios = async () => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}common/getquestion`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ addQuestion ~ err:", err);
    errMsg(err);
  }
};

export const getCmsAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}admin/cmslist`,
      ...(data ? { params: data } : {}),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getCmsAxios ~ err:", err);
    errMsg(err);
  }
};

export const addCmsAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/addcms`,
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ addCmsAxios ~ err:", err);
    errMsg(err);
  }
};

export const editCmsAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/cmsedit`,
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ editCmsAxios ~ err:", err);
    errMsg(err);
  }
};

export const subCategoryGet = async () => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}admin/getsubcategory`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ subCategoryGet ~ err:", err);
    errMsg(err);
  }
};

export const addSubcategory = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/addsubcat`,
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ addSubcategory ~ err:", err);
    errMsg(err);
  }
};

export const editSubCategory = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/editsubcat`,
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ editSubCategory ~ err:", err);
    errMsg(err);
  }
};

export const subcatHideShowAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/subcathideshow`,
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ subcatHideShowAxios ~ err:", err);
    errMsg(err);
  }
};


export const addExchangeListingAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/addEdafaceListing`,
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ subcatHideShowAxios ~ err:", err);
    errMsg(err);
  }
};

export const getListingsAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}admin/getListings`,
      params: data
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ subcatHideShowAxios ~ err:", err);
    errMsg(err);
  }
};

export const editEdafaceListing = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}admin/editEdafaceListing`,
      data: AppenData(data),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ subcatHideShowAxios ~ err:", err);
    errMsg(err);
  }
};

export const getFormsAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}admin/getForms`,
      params: data
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getFormsShowAxios ~ err:", err);
    errMsg(err);
  }
};

export const formStatusUpdate = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}admin/formStatusUpdate`,
      params: data
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getFormsShowAxios ~ err:", err);
    errMsg(err);
  }
};